import { render, staticRenderFns } from "./BaseConfirmModal.vue?vue&type=template&id=79e6fe30&scoped=true&lang=pug"
import script from "./BaseConfirmModal.vue?vue&type=script&lang=js"
export * from "./BaseConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./BaseConfirmModal.vue?vue&type=style&index=0&id=79e6fe30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e6fe30",
  null
  
)

export default component.exports